import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
  Card,
  Tooltip,
  notification,
  Button, Form, Popconfirm
} from 'antd'
import Request from '../../../request'
import { getPushPathWrapper } from '../../../routes'
import { connect } from 'react-redux'
import { TableComp, FormUtils } from 'sz-react-utils-lite'
import moment from 'moment'
import ReactHtmlParser from 'react-html-parser'
import { ChooseEmailModal, chooseEmailModalFxn, DisplayDate } from '../../../components/_utils/appUtils'
import { generateAndDepositXml, getAllArticle, viewGeneratedXml } from '../actions'
import { ArticleFilters } from '../articleView/articlePages'
import { SendTemplateEmail } from '../../email/actions'
import OnlinePublishDrawer from '../drawers/OnlinePublishDrawer'
import DOIDrawer from '../drawers/DOIDrawer'
import { API_URL } from '../../../request'

const publishArr = [
  { value: true, display: 'Publish', _id: 'publish' },
  { value: false, display: 'Un-Publish', _id: 'unpublish' }
]

@Form.create()
class DOIArticle extends Component {
  state = {
    edit: false,
    journalList: [],
    volumeList: [],
    issueList: [],
    isPublished: null,
    slugJournal: null,
    slugVolume: null,
    slugIssue: null,
    articleId: null,
    filters: {},
    visibleDrawer: false,
    article: {},
    total: ''
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let { dispatch, form: { getFieldValue } } = this.props
      let obj = {
        ...params,
        ...this.state.filters,
        articleStatus: 'DOI'
      }
      let regExpFilters = []

      let data = await dispatch(getAllArticle({ ...obj, regExFilters: regExpFilters }))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => {
    this.table.current.reload()
  }

  doiEvents = {
    viewDoiXml: async (article) => {
      let { success, message, filePath } = await this.props.dispatch(viewGeneratedXml({ articleId: article._id }))
      if (success) {
        /* notification.success({
           message: message
         })*/
        window.open(`${API_URL}${filePath}`, '_blank')
      }
    },
    depositDoiXml: async (article) => {
      let { success, message } = await this.props.dispatch(generateAndDepositXml({ articleId: article._id }))
      if (success) {
        notification.success({
          message: message
        })
        this.reload()
      }
    }
  }

  reloadTable = (data) => {
    if (data.fromDate && data.toDate) {
      data['submittedDate'] = {
        $gte: data.fromDate,
        $lte: data.toDate
      }
      delete data['fromDate']
      delete data['toDate']
    }
    this.setState({ filters: data }, () => {
      this.reload()
    })
  }

  deleteArticle = async (data) => {
    let resp = await Request.deleteArticle(data)
    this.reload()
  }

  sendMailFxn = (record) => {
    let { dispatch } = this.props
    chooseEmailModalFxn({
      callback: async (email) => {
        let obj = {
          articleId: record._id,
          fromEmail: email,
          emailType: 'acknowledgement',
          template: record.processingCharges > 0 ? 'acknowledgementWithCharges' : 'acknowledgementWithoutCharges',
          type: 'article'
        }
        let resp = await dispatch(SendTemplateEmail({
          email,
          id: record._id,
          obj,
          template: obj.template
        }))
        if (resp && resp.success) {
          notification.success({
            message: resp.message
          })
          this.reload()
        }

      }
    })
  }

  render() {

    const { dispatch, form: { getFieldDecorator, getFieldValue, setFieldsValue }, loading } = this.props
    const { journalList, volumeList, issueList } = this.state

    const formProps = {
      getFieldDecorator, getFieldValue, loading
    }


    const columns = [
      {
        key: 'actions',
        title: 'Article Id',
        width: '85px',
        render: (val, record) => (
          <Tooltip title='Edit Details'>
            <a href={`/articleView/${record._id}`}>
              {record.articleNo}
            </a>
          </Tooltip>

        )
      },
      {
        title: 'Submitted Date',
        key: 'submittedDate',
        dataIndex: 'submittedDate',
        width: 100,
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'ManuScript Title',
        key: 'manuScriptTitle',
        render: (item) => {
          return item ? ReactHtmlParser(item) : null
        }
      },
      {
        title: 'Country',
        key: 'country'
      },
      {
        title: 'Author',
        key: 'correspondingAuthor'
      },
      {
        title: 'Email',
        key: 'correspondingAuthorsEmail'
      },
      {
        title: 'Acceptance Date',
        key: 'acceptedArticlePaymentDate',
        dataIndex: 'acceptedArticlePaymentDate',
        width: 100,
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Gallery Proof Date',
        key: 'sendgalleyProofDate',
        width: 100,
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'DOI Date',
        key: 'doiProcessDate',
        width: 100,
        render: (item) => {
          return item ? DisplayDate(item) : null
        }
      },
      {
        title: 'Action',
        key: 'Action',
        render: (item, record) => {
          return (
            <>
              <Button className={'roundSmallBtn'}
                      onClick={() => this.setState({ visibleDrawer: true, article: record })}>
                Online Publication
              </Button>

              <Button className={'roundSmallBtn'}
                      onClick={() => this.doiEvents.viewDoiXml(record)}>
                View DOI XML
              </Button>
              <Popconfirm placement='topLeft' title={`Are you sure you want to Generate XML?`}
                          onConfirm={() => this.doiEvents.depositDoiXml(record)} okText='Yes' cancelText='No'>
                <Button className={'roundSmallBtn'}>
                  Deposit DOI XML
                </Button>
              </Popconfirm>

            </>
          )
        }
      }


    ]

    const fil =
      {
        labelCol: {
          xs: {
            span: 24
          }
          ,
          sm: {
            span: 24
          }
          ,
          md: {
            span: 24
          }
        }
        ,
        wrapperCol: {
          xs: {
            span: 24
          }
          ,
          sm: {
            span: 24
          }
          ,
          md: {
            span: 24
          }
        }
      }

    return (
      <PageHeaderWrapper
        title={`DOI Articles (${this.state.total})`}>
        <Card bordered={true}>
          <ArticleFilters callback={(data) => {
            this.reloadTable(data)
          }} />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>
        {this.state.visibleDrawer ? <OnlinePublishDrawer
          visible={this.state.visibleDrawer}
          articleId={this.state.article._id}
          article={this.state.article}
          Id={this.state.article._id}
          callback={this.reload}
          edit={false}
          onClose={() => this.setState({ visibleDrawer: false })}
        /> : null}

      </PageHeaderWrapper>
    )

  }
}


const mapStateToProps = (
  {
    global
  }
) => (
  {
    categories: global.categories
  }
)
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DOIArticle)
